import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { UsersAndGroupsService } from '../_services/users-and-groups.service';
import { AppConfig } from 'src/assets/config/config/app-config';

@Component({
  selector: 'app-saml-login',
  templateUrl: './saml-login.component.html',
  styleUrls: ['./saml-login.component.scss']
})
export class SAMLLoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private usersGroupsService: UsersAndGroupsService,
    public router: Router,
    private config: AppConfig
  ) { }

  ngOnInit() {
    this.login()
  }

  async login() {
    let userObj = null;
    userObj = localStorage.getItem('currentUser');
    let code = this.route.snapshot.queryParams['code'];
    console.log(this.route, code);
    if (code != undefined) {
      let body = {
        access_token: code
      }
      let res = null;
      try {

        console.log('Before making the GetToken call')
        res = await this.authenticationService.getToken(body).toPromise()

        console.log('After making the GetToken call')
      } catch (err) {
        if(err['error']['status_code'] === 500) {
          console.log(err)
          localStorage.clear();
          let auth_uri = this.config.getConfig('redirect_uri')
          window.location.href = auth_uri
          return;
        }
        console.log(err)
        localStorage.clear();
        // window.location.href = window.location.href.split('?')[0]
        alert('Unable to authorize user and fetch user details. Please contact your administrator')
        return;
      }
    
      if (res == null || res['token'] === null) {
        localStorage.clear();
        window.location.href = window.location.href.split('?')[0]
      }
      let currentUserObject = null;
      if (res != null) {
        currentUserObject = {
          username: res['username'],
          token: res['token']
        }
        localStorage.setItem("currentUser", JSON.stringify(currentUserObject));
        this.authenticationService.currentUserSubject.next(currentUserObject);
        localStorage.setItem('userGroups', JSON.stringify(res['groups']));
        let groups = res['groups']; 
        this.authenticationService.userGroupsSubject.next(groups);
        let adminGroup = [];    
        this.usersGroupsService.getAdminGroupName().subscribe((admin:any) => {
          adminGroup = admin;
          for (let i = 0; i < groups.length; i++) {
              if (adminGroup.indexOf(groups[i]) >= 0) {
                  localStorage.setItem('isAdmin', JSON.stringify(true))
                  this.authenticationService.isAdminSubject.next(true);
                  break;
              }
          }
          this.router.navigate(['/categories']);
        });   
      }
    } else {            
      let redirect_uri = encodeURI(this.config.getConfig('redirect_uri'));
      window.location.href = redirect_uri;
    }
  }

}
